import * as React from 'react';
import styled from 'styled-components/macro';
import { MdClose } from 'react-icons/md';
//types
import { VideoChapterItemExtended } from 'types';

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
`;

const Content = styled.div`
  margin-top: 4px;
  display: flex;
  flex-direction: column;
  align-items: baseline;
  justify-content: space-between;
  overflow-x: hidden;
  overflow-y: auto;
  max-height: calc(100% - 30px);
  gap: 12px;
  ::-webkit-scrollbar {
    height: 24px;
    width: 4px;
  }
  ::-webkit-scrollbar-thumb {
    border-radius: 8px;
    background-color: rgba(0, 27, 83, 0.2);
  }
  ::-webkit-scrollbar {
    -webkit-appearance: none;
  }
  ::-webkit-scrollbar-track {
    background-color: transparent;
  }
`;
const CloseButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  margin: 0;
  padding: 0;
  margin-left: auto;
  color: ${props => props.theme.colors.black[100]};
  cursor: pointer;
`;
const ChapterWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  flex-direction: row;
  justify-content: center;
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 20px;
  cursor: pointer;
`;
const ChapterTime = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 2px 8px;
  width: 49px;
  min-width: 49px;
  height: 24px;
  background: ${props => props.theme.colors.secondary[5]};
  border-radius: 6px;
  font-feature-settings:
    'tnum' on,
    'lnum' on;
  color: ${props => props.theme.colors.secondary[80]};
`;
const ChapterTitle = styled.div`
  color: #272a32;
  margin-left: 8px;
`;
const MainWrapper = styled.div`
  display: block;
  position: absolute;
  max-height: calc(100% - 130px);
  padding: 12px;
  width: 319px;
  max-width: 50%;
  top: 8px;
  bottom: 0;
  right: 8px;
  background-color: white;
  z-index: 99;
  border-radius: 6px;

  @media screen and (max-width: 640px) {
    width: calc(100% - 40px);
    max-width: 100%;
    max-height: 100%;
    top: 8px;
    left: 8px;
    right: 8px;
    bottom: 50px;
  }
`;

type Props = {
  handleCloseModal: () => void;
  onChapterClick: (playbackPosition: number) => void;
  chapters: VideoChapterItemExtended[];
};
export const ModalChapters = ({
  handleCloseModal,
  chapters,
  onChapterClick,
}: Props) => {
  return (
    <MainWrapper>
      <Header>
        <CloseButtonWrapper>
          <MdClose color={'#272A32'} size={24} onClick={handleCloseModal} />
        </CloseButtonWrapper>
      </Header>
      <Content>
        {chapters.map(chapter => (
          <ChapterWrapper
            key={chapter.playbackPositionText + chapter.title}
            onClick={() => onChapterClick(chapter.playbackPosition)}
          >
            <ChapterTime>{chapter.playbackPositionText}</ChapterTime>
            <ChapterTitle>{chapter.title}</ChapterTitle>
          </ChapterWrapper>
        ))}
      </Content>
    </MainWrapper>
  );
};
